import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
  selector: 'red-numeric-buttons-input',
  standalone: false,
  templateUrl: './numeric-buttons-input.component.html'
})
export class NumericButtonsInputComponent implements AfterViewInit {
  ngControl = inject(NgControl);
  private changeDetectorRef = inject(ChangeDetectorRef);

  value = 0;

  ngAfterViewInit() {
    this.value = this.ngControl.control?.value;
    this.changeDetectorRef.detectChanges();
    this.ngControl.control?.valueChanges.subscribe((value) => {
      this.value = value;
      this.changeDetectorRef.detectChanges();
    });
  }

  decrease() {
    if (this.value > 0) {
      this.ngControl.control?.setValue(this.value - 1);
      this.ngControl.control?.markAsDirty();
    }
  }

  increase() {
    this.ngControl.control?.setValue(this.value + 1);
    this.ngControl.control?.markAsDirty();
  }
}
